import { IndexeddbAudioBackup } from "./IndexeddbAudioBackup";
import * as AudioBackup from "../interfaces/IAudioBackup";
import { LogError} from '../../utils/ErrorTelemetry';
import { LogEventNames } from "../interfaces/ITelemetryLogger";
import { IndexeddbAudioBackupDummy } from "./IndexeddbAudioBackupDummy";

export function CreateDefaultAudioBackup(backendToUse: AudioBackup.SupportedBackends = AudioBackup.SupportedBackends.indexeddb): AudioBackup.IAudioBackup {
    switch (backendToUse) {
        case AudioBackup.SupportedBackends.indexeddb:

            if (window.indexedDB == null) {
                LogError(LogEventNames.Warning, 'Null indexeddb found, browser unsupported');
                return new IndexeddbAudioBackupDummy();
            } else {
                return new IndexeddbAudioBackup(window.indexedDB);
            }
        default:
            LogError(LogEventNames.Warning, "Unknown backendToUse: " + backendToUse);
            return new IndexeddbAudioBackupDummy();
    }
}